import { InjectionToken } from '@angular/core';
import { IFilterModalServiceType } from '../services';

export const MED_FILTER_MODAL_SERVICE = new InjectionToken<IFilterModalServiceType>('MED_FILTER_MODAL_SERVICE');
